import { FC, memo, useMemo, ReactNode } from 'react';
import { CalendarWeekDays } from '../calendar-week-days';
import { CalendarHeader } from '../calendar-header';
import { makeCalendar } from '../make-calendar';
import { Timestamp } from '../types';
import styles from './Cal.module.scss';

type Props = {
  monthTimestamp: Timestamp;
  title?: string;
  isInline?: boolean;
  style?: React.CSSProperties;
  position?: 'topLeft' | 'topRight' | 'topCenter' | 'bottomLeft' | 'bottomRight';
  startYearOffset?: number;
  setDropDownValue: (monthTimestamp: Timestamp) => void;
  children: (dayTimestamp: Timestamp) => ReactNode;
};

const Calendar: FC<Props> = ({
  title,
  children,
  monthTimestamp,
  isInline = false,
  setDropDownValue,
  position,
  style,
  startYearOffset,
}) => {
  const calendar = useMemo(() => makeCalendar(monthTimestamp), [monthTimestamp]);
  function getInlineClass() {
    return isInline ? 'isInline' : '';
  }

  return (
    <div
      className={[styles.calendarContainer, styles[position || ''], styles[getInlineClass()]].join(' ')}
      style={style}
      {...(!isInline && {
        role: 'dialog',
      })}
    >
      <CalendarHeader
        title={title}
        monthTimestamp={monthTimestamp}
        setDropDownValue={setDropDownValue}
        startYearOffset={startYearOffset}
      />
      <table>
        <thead>
          <CalendarWeekDays />
        </thead>
        <tbody>
          {calendar.map((week, index) => (
            <tr key={String(index)}>
              {week.map((day) => (
                <td key={day}>{children(day)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const CalendarMemo = memo(Calendar);
export { CalendarMemo as Calendar };
